if (customElements && !customElements.get('info-strips')) {
  class InfoStrips extends HTMLElement {
    constructor() {
      super();
      this.splits = [];
      this.timeline = null;
    }

    connectedCallback() {
      if (this.dataset.animate !== 'true') {
        return;
      }

      if (
        typeof gsap === 'undefined' ||
        typeof SplitText === 'undefined' ||
        typeof ScrollTrigger === 'undefined'
      ) {
        console.error('Info strips: GSAP, SplitText or ScrollTrigger not found');
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      gsap.registerPlugin(SplitText, ScrollTrigger);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.init());
      } else {
        this.init();
      }
    }

    revealText(element, position) {
      const split = SplitText.create(element, {
        type: 'lines, words',
        mask: 'lines',
        linesClass: 'info-strips__line',
        wordsClass: 'info-strips__word'
      });

      if (!split.words.length) {
        split.revert();
        return;
      }

      this.splits.push(split);
      gsap.set(split.words, { yPercent: 100 });

      this.timeline.to(
        split.words,
        {
          yPercent: 0,
          duration: 0.8,
          ease: 'power3.out',
          stagger: { each: 0.035 }
        },
        position
      );
    }

    init() {
      this.timeline = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'bottom bottom+=10%',
          once: true
        }
      });

      const title = this.querySelector('[data-role="info-strips-title"]');

      if (title) {
        this.revealText(title, 0);
      }

      const items = [...this.querySelectorAll('[data-role="info-strips-item"]')];
      const blocksPosition = title ? 0.3 : 0;

      items.forEach((item) => {
        const icon = item.querySelector('.info-strip__icon');
        const heading = item.querySelector('.info-strip__title');
        const description = item.querySelector('.info-strip__description');

        if (icon) {
          gsap.set(icon, { autoAlpha: 0, y: 16 });
          this.timeline.to(
            icon,
            { autoAlpha: 1, y: 0, duration: 0.55, ease: 'power2.out' },
            blocksPosition
          );
        }

        if (heading) {
          this.revealText(heading, blocksPosition);
        }

        if (description) {
          this.revealText(description, blocksPosition);
        }
      });

      if (!this.splits.length) {
        if (this.timeline.scrollTrigger) {
          this.timeline.scrollTrigger.kill();
        }

        this.timeline.kill();
        this.timeline = null;
      }
    }

    disconnectedCallback() {
      if (this.timeline) {
        if (this.timeline.scrollTrigger) {
          this.timeline.scrollTrigger.kill();
        }

        this.timeline.kill();
        this.timeline = null;
      }

      this.splits.forEach((split) => {
        split.revert();
      });

      this.splits = [];
    }
  }

  customElements.define('info-strips', InfoStrips);
}
